import Ratecon from "./Ratecon";

export default Ratecon;
